




import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import { debounce } from "@/utils";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class LineChart extends Vue {
  public 0;
  @Prop({ default: "chart" }) private className!: string;
  @Prop({ default: "100%" }) private width!: string;
  @Prop({ default: "400px" }) private height!: string;
  @Prop({ default: "true" }) private autoResize!: boolean;
  @Prop({ required: true }) private chartData!: any;
  @Prop({ default: "" }) private unit!: any;
  private chart: echarts.ECharts | undefined = undefined;
  private sidebarElm: Element | undefined = undefined;

  @Watch("chartData", { deep: true })
  public onChangeValue(val) {
    this.setOptions(val);
  }

  public mounted() {
    this.initChart();
    if (this.autoResize) {
      window.addEventListener("resize", this.__resizeHandler);
    }
    // 监听侧边栏的变化
    this.sidebarElm = document.getElementsByClassName("sidebar-container")[0];
    this.sidebarElm &&
      this.sidebarElm.addEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
  }

  /**
   * name
   */
  public __resizeHandler() {
    debounce(
      () => {
        if (this.chart) {
          this.chart.resize();
        }
      },
      100,
      false
    )();
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }

    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );

    this.chart.dispose();
    this.chart = undefined;
  }

  public sidebarResizeHandler(e) {
    if (e.propertyName === "width") {
      this.__resizeHandler();
    }
  }

  public setOptions(showData: any) {
    if (!this.chart) {
      return;
    }
    let option = {
      xAxis: {
        data: showData.xDatas,
        boundaryGap: true,
        axisTick: {
          show: false
        }
      },
      yAxis: [
        {
          name: "usage",
          axisLabel: {
            formatter: "{value}" +" "+ this.unit
          }
        }
      ],
      legend: {
        data: ["expected"]
      },
      series: [
        {
          barMaxWidth: "60px",
          name: "usage",
          itemStyle: {
            normal: {
              color: "#409EFF",
              lineStyle: {
                color: "#409EFF",
                width: 2
              }
            }
          },
          smooth: false,
          type: "bar",
          data: showData.usages,
          animationDuration: 0,
          animationEasing: "cubicInOut"
        }
      ]
    };
    this.chart.setOption(option);
  }

  public initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, "macarons");
    this.setOptions(this.chartData);
  }
}
